export default __webpack_public_path__ + "static/nurture-c83bb1dee875b640be1265f64599d768.jpg";